module.exports = __webpack_public_path__ + "img/dateapproval.9e3e8509.svg";